'use strict';

// Bootstraps yargs for ESM:
import esmPlatformShim from './lib/platform-shims/esm.mjs';
import {YargsFactory} from './build/lib/yargs-factory.js';

const Yargs = YargsFactory(esmPlatformShim);
export default Yargs;
